<template>
    <v-snackbar top  v-model="snackbar" :color="colour" :timeout="timeout">
        {{ text }}
        <template v-slot:action="{ attrs }">
            <v-btn color="blue" text v-bind="attrs" @click="snackbar = false">
                Close
            </v-btn>
        </template>
    </v-snackbar>
</template>



<script>
    export default {
        data() {
            return {
                snackbar: false,
                text: 'My timeout is set to 2000.',
                timeout: 2000,
                colour:"primary"
            }
        },
        methods: {
            show(config) {
                let self = this
                self.text = config.text
                self.colour = config.colour
                self.snackbar = true
            }
        }
    }
</script>